export default __webpack_public_path__ + "static/156-757a00aee7c1d822ffb5490bb803bcec.jpg";